<template>
  <v-container class="body-2 ma-0 pa-0">
    <template v-for="(item, itemIndex) in list">
      <v-row>
        <v-col
          cols="5"
          class="py-1 grey--text"
        >
          {{ item.label }}
        </v-col>
        <v-col
          cols="7"
          class="py-1"
        >
          <template v-if="(Array.isArray(item.value))">
            <div
              v-for="(value, valueIndex) in item.value"
              :key="valueIndex"
            >
              {{ value }}
            </div>
          </template>

          <template v-else>
            <div> {{ item.value }}</div>
          </template>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => ([])
    }
  },
}
</script>
